import React, { useState, useRef } from "react";
import FilterPopover from "./FilterPopover";

const FilterableHeader = ({
  title,
  filterKey,
  filterType,
  currentValue,
  options = [],
  placeholder = "",
  helpers,
  onFilterChange,
  onFilterClear,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const buttonRef = useRef(null);

  const hasActiveFilter = () => {
    if (Array.isArray(currentValue)) {
      return currentValue.length > 0;
    }
    return currentValue && currentValue.toString().trim() !== "";
  };

  const getFilterIndicator = () => {
    if (!hasActiveFilter()) return null;

    if (Array.isArray(currentValue)) {
      return (
        <span className="badge bg-primary ms-1" style={{ fontSize: "0.7em" }}>
          {currentValue.length}
        </span>
      );
    }

    return (
      <span className="badge bg-primary ms-1" style={{ fontSize: "0.7em" }}>
        •
      </span>
    );
  };

  return (
    <div>
      <button
        ref={buttonRef}
        type="button"
        className={`btn btn-sm rounded-full bg-white border-0 shadow-sm  ${
          hasActiveFilter() ? "btn-primary" : "btn-default text-muted"
        }`}
        style={{
          padding: "2px 8px",
          fontSize: "0.75em",
        }}
        onClick={() => setIsPopoverOpen(true)}
        title={`Filtrer par ${title.toLowerCase()}`}
      >
        <i className="fa fa-filter" />
        {getFilterIndicator()}
      </button>

      <FilterPopover
        isOpen={isPopoverOpen}
        onClose={() => setIsPopoverOpen(false)}
        onApply={(value) => onFilterChange(filterKey, value)}
        onClear={() => onFilterClear(filterKey)}
        filterType={filterType}
        currentValue={currentValue}
        options={options}
        placeholder={placeholder}
        helpers={helpers}
        buttonRef={buttonRef}
        label={`Filtrer par ${title.toLowerCase()}`}
      />
    </div>
  );
};

export default FilterableHeader;
